import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Consulta } from 'src/core/consulta/consulta.types';
import { RequestConsultaConfirmarCita } from 'src/core/consulta/consulta.types';
import { OkcancelDialogComponent } from '../okcancel-dialog/okcancel-dialog.component';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Router } from '@angular/router';
import { CommonComponent } from '../common-component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { Atencion } from 'src/core/atencion/atencion.types';
import { User } from 'src/core/user/user.types';
import { UserService } from 'src/core/user/user.service';

@Component({
  selector: 'app-appointment-veterinaria',
  templateUrl: './appointment-veterinaria.component.html',
  styleUrls: ['./appointment-veterinaria.component.css']
})
  export class AppointmentVeterinariaComponent extends CommonComponent implements OnInit{
    userSession: User = {} as User;
    @Input('consulta') consulta: Consulta;
    now = new Date();
    fechaCita = null;  
    confirmarCita: RequestConsultaConfirmarCita = {
      idCita: 0, // Provide default values or undefined
      correo: '',
      dia: '',
      hora: '',
      nombreUsuarioCliente: '',
      numeroCliente: ''
    }; // Initialize with required properties
  estadoConsulta = {1:'Pendiente por Confirmación',2:'Confirmada',3:'En Espera de Pago',4:'Rechazada'
    ,5:'Reprogramada',6:'Finalizada',7:'Solicitar reagendamiento'};
  diasSemana: string[] = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];

  constructor(
    public _dialog: MatDialog,
    private _router: Router,
    private _consultaService: ConsultaService,
    private _atencioneService: AtencionService,
    private _userService: UserService,
    _snackBar: MatSnackBar
  ){
    super(_snackBar);
  }

  ngOnInit(): void {
    console.log('aquie ven aqui');
    this.fechaCita = new Date(this.consulta.consultaFechaCita+"T"+this.consulta.consultaHoraCita);
    this.getUserSession();
  }
  reagendar(){
    this._consultaService.Consulta = this.consulta;
    //this._router.navigateByUrl('/client/schedule-appointment/reschedule');
    this._router.navigate(['/client/schedule-appointment/', 'reschedule']);
  }

  getUserSession(){
    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }
  confirm(){
    const message = `Confirmar la cita para el ${this.consulta.consultaFechaCita} a las ${this.consulta.consultaHoraCita} con un costo de consulta de $ ${this.consulta.consultaCostoConsulta}`;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: {message: message}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.aceptarCita();
      }
    });
  }

  

  cancel(){
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      data: {message: '¿Está seguro que desea cancelar la cita?'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this._consultaService.Consulta = this.consulta;
        this.cancelarCita();
      }
    });
  }


  aceptarCita(){
    console.log('consulta select : ', this.consulta);
    this._consultaService.aceptarCita(this.confirmarCitaMapper(),this.consulta).subscribe({
      next: (response: any) => {
        this._router.navigateByUrl('vets/appointment-detail');
      },
      error: (error: any) => {
        this.openSnackBar(`Error al confirmar cita: ${error.error.status}`);
      }
    });
  }
  cancelarCita(){
    console.log('consulta select : ', this.consulta);
    this._consultaService.cancelarCita(this.consulta).subscribe({
      next: (response: any) => {
        this.openSnackBar(`Cita cancelada`);
      },
      error: (error: any) => {
        console.log(JSON.stringify(error));
        this.openSnackBar(`${error}`);
      }
    });
  }

  confirmarCitaMapper(){    
    this.confirmarCita.idCita =  this.consulta.consultaId;
    this.confirmarCita.correo = this.userSession.correo;
    this.confirmarCita.dia = this.consulta.consultaFechaCita;
    this.confirmarCita.hora = this.consulta.consultaHoraCita;
    this.confirmarCita.nombreUsuarioCliente = this.consulta.nombreUsuario;    
    return this.confirmarCita;
  }

  confirmPayment(){
    console.log('Pagar cita');
    const message = `Pagar la cita para el ${this.consulta.consultaFechaCita} a las ${this.consulta.consultaHoraCita} con un costo de consulta de $ ${this.consulta.consultaCostoConsulta}`;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: {message: message}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        //this.aceptarCita();
        console.log('Pasar a pagar:',this.consulta);
        console.log('Data: ',this.confirmarCitaMapper());
        
        this._consultaService.confirmarPago(this.confirmarCitaMapper(),this.consulta).subscribe({
          next: (response: any) => {
            window.location.reload();
          },
          error: (error: any) => {
            this.openSnackBar(`Error al confirmar cita: ${error.error.status}`);
          }
        });
        
      }
    });
  }

}
